import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'
import { getFocusVisibleStyle } from '@Styles/focus'

export const icon = (theme: Theme): SerializedStyles =>
  css({
    fill: theme.palette.text.primary,
    height: rem(20),
  })

export const buttonFocus = (theme: Theme): SerializedStyles =>
  css({
    '&:focus-visible::before': getFocusVisibleStyle(theme.palette.primary.main, RADIUS_1, '0'),
  })
